import { useContext } from 'react';

import { MobileLayoutContext } from '../../contexts/MobileLayoutContext';
import { MobileFoldersWorkspacePage, WorkspaceCanvasPage } from '../../lazyPages';

/**
 * The workspace page for the shell it renders in: the mobile
 * workspace inside the phone shell, the desktop canvas everywhere else.
 *
 * Keyed on `MobileLayoutContext` (provided only by `MobileLayout`) rather than
 * a second viewport check, so the page always matches the shell `Layout`
 * already chose: a folder opened from the mobile list (its bare
 * `/collections/:id` path) never renders the desktop canvas inside the phone
 * shell.
 */
export function WorkspacePageForShell() {
  const inPhoneShell = useContext(MobileLayoutContext) !== null;
  return inPhoneShell ? <MobileFoldersWorkspacePage /> : <WorkspaceCanvasPage />;
}
